import React from 'react';
import { withRouter } from 'react-router-dom';
import { getFormData } from '../../common';
import { EverestAdminRepository } from '../../repository';
import { NavigationBar } from './NavigationBar';

class MountainPeakDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mountainPeakId: props.match.params.mountainPeakId,
      mountainPeak: {}
    };

    this.everestRepository = new EverestAdminRepository();
  }

  componentDidMount() {
    const mountainPeakId = this.state.mountainPeakId;
    this.everestRepository.findMountainPeak({ mountainPeakId }, (data) => {
      this.setState({ mountainPeak: data });
    });
  }

  componentWillUnmount() {
    this.setState({ mountainPeak: {} });
  }

  onSubmit(e) {
    e.preventDefault();
    const formData = getFormData(e.target);
    this.everestRepository.updateMountainPeak(formData, () => {
      window.Toast.info("Completed!");
    });
  }

  onClickRepresent(e) {
    e.preventDefault();
    const mountainPeakId = this.state.mountainPeakId;
    const confirm = window.confirm(`${this.state.mountainPeak.peakName} (이)가 주봉이 됩니다.`);
    if (confirm) {
      this.everestRepository.representMountainPeak({ mountainPeakId }, () => {
        window.Toast.info("Completed!");
        this.everestRepository.findMountainPeak({ mountainPeakId }, (data) => {
          this.setState({ mountainPeak: data });
        });
      });
    }
  }

  onClickDelete(e) {
    e.preventDefault();
    const mountainPeakId = this.state.mountainPeakId;
    const confirm = window.confirm("Are you sure?");
    if (confirm) {
      this.everestRepository.deleteMountainPeak({ mountainPeakId }, () => {
        window.Toast.info("Completed!");
        window.history.back();
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <NavigationBar />

        <br />
        <div className={"container"}>
          <form className={"form-text-align-default"} onSubmit={this.onSubmit.bind(this)}>
            <input name={"mountainPeakId"} type={"hidden"} defaultValue={this.state.mountainPeakId}></input>
            <div className={"form-group"}>
              <label>mountainName</label>
              <div className={"form-control border-0"}>{this.state.mountainPeak.mountainName}</div>
            </div>
            <div className={"form-group"}>
              <label>peakName</label>
              <input name={"name"} className={"form-control"} type={"text"} defaultValue={this.state.mountainPeak.peakName}></input>
            </div>

            <div className={"form-group"}>
              <label>height</label>
              <input name={"height"} className={"form-control"} type={"text"} defaultValue={this.state.mountainPeak.height}></input>
            </div>

            <div className={"form-group"}>
              <label>latitude</label>
              <input name={"latitude"} className={"form-control"} type={"text"} defaultValue={this.state.mountainPeak.latitude}></input>
            </div>

            <div className={"form-group"}>
              <label>longitude</label>
              <input name={"longitude"} className={"form-control"} type={"text"} defaultValue={this.state.mountainPeak.longitude}></input>
            </div>

            <div className={"form-group"}>
              <label>represent</label>
              <div className={"form-control border-0"}>{this.state.mountainPeak.represent ? "메인" : "서브"}</div>
              {false && (
                <select className={"form-control"} defaultValue={this.state.mountainPeak.represent}>
                  <option value={""}>-선택-</option>
                  <option value={"true"}>메인</option>
                  <option value={"false"}>서브</option>
                </select>
              )}
            </div>

            {this.state.mountainPeak.id !== undefined && (
              <>
                {!this.state.mountainPeak.peakDeleted && (
                  <div className={"form-group"}>
                    <button className={"btn btn-primary"} type={"submit"}>수정</button>&nbsp;
                    <button className={"btn btn-info"} onClick={this.onClickRepresent.bind(this)}>주봉</button>&nbsp;
                    <button className={"btn btn-danger"} onClick={this.onClickDelete.bind(this)}>삭제</button>
                  </div>
                )}
                {this.state.mountainPeak.peakDeleted && (
                  <p style={{ color: "#f00" }}>삭제 완료</p>
                )}
              </>
            )}

          </form>
        </div>
      </React.Fragment>
    );
  }
}

var MountainPeakDetailWithRouter = withRouter(MountainPeakDetail);
export { MountainPeakDetailWithRouter as MountainPeakDetail };
